<!-- Widgets Row -->
<div class="row">
  <app-cards
    [label]="stationLabel"
    [value]="stationCount > 0 ? stationCount : 0"
    [subtitle]="stationLabel"
    [iconBgColor]="'#B32317'"
    [icon]="'fas fa-church'"
    [iconType]="'fa'"
    (click)="viewOutStations()">
  </app-cards>

  <app-cards
    *ngIf="hierarchyDepth >= 3"
    [label]="communityLabel"
    [value]="communityCount > 0 ? communityCount : 0"
    [subtitle]="communityLabel"
    [iconBgColor]="'#49A942'"
    [icon]="'fas fa-map-marked-alt'"
    [iconType]="'fa'"
    (click)="viewCommunity()">
  </app-cards>

  <app-cards
    [label]="'Groups'"
    [value]="groupsCount > 0 ? groupsCount : 0"
    [subtitle]="'Groups'"
    [iconBgColor]="'#221F20'"
    [icon]="'fas fa-users'"
    [iconType]="'fa'"
    (click)="viewGroups()">
  </app-cards>

  <app-cards
    [label]="'System Users'"
    [value]="usersCount > 0 ? usersCount : 0"
    [subtitle]="'System Users'"
    [iconBgColor]="'#8F1C12'"
    [icon]="'fas fa-user-circle'"
    [iconType]="'fa'"
    (click)="viewUsers()">
  </app-cards>
</div>
